import React, { useEffect } from 'react';
import { Link } from "react-router-dom"
import logo from '../../../img/logo-nd.png';

const Navbar = () => {
    let toggleMenu = () => {
        document.body.classList.toggle('menu-toggle');
    }
    useEffect(() => {
        if (window.matchMedia("(max-width: 576px)").matches) {
            document.body.classList.toggle('menu-toggle');
          } else {
            document.body.classList.remove('menu-toggle');
          }
    })

    return (
        <nav className="menu" id="menu">
            <div className="menu-wrapper">
                <button id="toggle-menu" className="slide-menu" onClick={ () => toggleMenu() }><i className="material-icons">transit_enterexit</i></button>
                <h1>
                    <img src={ logo } alt="Norddigital" />
                    <small>Norddigital CMS</small>
                </h1>
                <ul>
                    <li>
                        <Link to="/dashboard">
                            <i className="material-icons">dashboard</i>
                            <span>Strona główna</span>
                        </Link>
                    </li>
                    
                    <li>
                        <Link to="/dashboard/users">
                            <i className="material-icons">people</i>
                            <span>Użytkownicy</span>
                        </Link>
                        <ul>
                            <li>
                                <Link to="/dashboard/users/new">
                                    <i className="material-icons">add</i>
                                    <span>Nowy</span>
                                </Link> 
                            </li>
                        </ul>
                    </li>
                    <li>
                        <Link to="/dashboard/slider">
                            <i className="material-icons">slideshow</i>
                            <span>Slider</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/dashboard/localities">
                            <i className="material-icons">house</i>
                            <span>Miejscowości</span>
                        </Link>
                        <ul>
                            <li>
                                <Link to="/dashboard/localities/new">
                                    <i className="material-icons">add</i>
                                    <span>Nowa</span>
                                </Link> 
                            </li>
                            <li>
                                <Link to="/dashboard/localities/group-languages">
                                    <i className="material-icons">language</i>
                                    <span>Grupy językowe</span>
                                </Link> 
                            </li>
                        </ul>
                    </li>
                    <li>
                        <Link to="/dashboard/atractions">
                            <i className="material-icons">location_city</i>
                            <span>Atrakcje</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/dashboard/translate">
                            <i className="material-icons">g_translate</i>
                            <span>Tłumaczenia</span>
                        </Link>
                    </li>
                    {/* <li>
                        <Link to="/dashboard/map-settings">
                            <i className="material-icons">settings_applications</i>
                            <span>Ustawienia mapy</span>
                        </Link>
                    </li> */}
                </ul>
                <a href="http://norddigital.com" className="description" alt="NordDigital" target="_blank">
                    <img src={ logo } />
                    <span> Created by NordDigital</span>
                </a>
            </div>
            <div className="menu-bg"></div>
        </nav>
    );
}

export default Navbar;
